import { axiosInstance } from "api/axios-config/axios-config";
import { GetExportExcelDeliveryNotes } from "api/models/request/delivery-note/delivery-note";
import { DEFAULT_VOUCHER_SLICE_SIZE } from "commons/constants";
import {
  IAddDeliveryNote,
  IDeliveryNoteProperties,
  IUpdateDeliveryNote,
} from "mobx-stores/_models/delivery-note/delivery-note";
import { BaseBussiness } from "../base";

class DeliveryNoteBusiness extends BaseBussiness<
  IDeliveryNoteProperties,
  IAddDeliveryNote,
  IUpdateDeliveryNote,
  IDeliveryNoteProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public searchDeliveryNotes = async (keyword: string) => {
    const res = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_VOUCHER_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });

    return res;
  };

  public exportExcel = async (request: GetExportExcelDeliveryNotes) => {
    try {
      var res = await axiosInstance.get(this.url + "/export-excel", {
        params: request,
        responseType: "blob",
      });
      // 🔍 Extract filename from Content-Disposition

      // const disposition = res.headers["Content-Disposition"];
      // let filename = "export.xlsx"; // fallback
      // const match = disposition?.match(
      //   /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      // );
      // if (match && match[1]) {
      //   filename = match[1].replace(/['"]/g, "");
      // }
      // return {
      //   blob: res.data as Blob,
      //   filename,
      // };
      return res.data as Blob;
    } catch (error) {
      console.error("Fail exportExcel", error);
      return Promise.reject(error);
    }
  };
}

export const deliveryNoteBusiness = new DeliveryNoteBusiness(
  "/api/app/delivery-note",
);
